import { Bus } from '@/plugins/api'
import { chunk, flatten } from 'lodash-es'
import { Student, BusStudent, BusStop } from '../../plugins/api'
import constant from '@/store/other/constant'

const weekdaysObj = constant.weekdaysObj

export default {
  namespaced: true,
  state: {
    loading: false,
    busData: {},
    count: 0,
    search: [],
    pageText: '',
    itemsPerPage: 10,
    busSearchParams: {},
    totalItems: 0,
    studentBuses: [],
    busStudents: [],
  },
  actions: {
    async fetchBusStudents({ commit }, params) {
      const buses = await Bus.fetch({ _limit: -1 })

      let studentIds = {}
      buses.map((bus) => {
        let ids = flatten(bus.busStops.map((bs) => bs.students))
        ids = [...new Set(ids)]
        ids.map((studentId) => {
          studentIds[`${studentId}`] = studentIds[`${studentId}`] ? [...studentIds[`${studentId}`], bus] : [bus]
        })
      })

      let students = []
      if (params.student) {
        const s = await Student.fetchOne(params.student)
        students.push(s)
      } else {
        const groups = chunk(Object.keys(studentIds), 10)
        for (const subStudentIds of groups) {
          const studentList = await Promise.all(subStudentIds.map((id) => Student.fetchOne(id)))
          students.push(...studentList)
        }
      }

      if (!params.student && params.currentClass) {
        students = students.filter((s) => s.currentClass && s.currentClass.id === params.currentClass)
      } else if (!params.student && params.grade) {
        students = students.filter((s) => s.grade && s.grade.id === params.grade)
      }

      const studentBuses = []
      students.map((student) => {
        const studentBusStops = []
        const buses = studentIds[`${student.id}`]
        if (buses) {
          const mappingBuses = buses.map((bus) => {
            const tempBus = { ...bus }
            let weekDays = []
            tempBus.busStops.map((bs) => {
              if (bs.students.includes(student.id)) {
                studentBusStops.push(bs)
                weekDays.push(bs.day)
              }
            })
            weekDays = [...new Set(weekDays)]
            const sortedWeekDays = weekDays.sort((a, b) => weekdaysObj[`${a}`].index - weekdaysObj[`${b}`].index)

            tempBus['weekDays'] = sortedWeekDays
            if (weekDays.length > 0 && weekDays.length < 6) tempBus['showWeekDays'] = true
            else tempBus['showWeekDays'] = false

            return tempBus
          })

          const obj = {
            student,
            studentBusStops,
            buses: mappingBuses,
          }
          studentBuses.push(obj)
        }
      })

      commit('changeState', { studentBuses })
    },
    async getBusStudents({ commit }, params) {
      let Params = { ...params }
      commit('changeState', { loading: true })
      const [totalItems, busStudents] = await Promise.all([BusStudent.count(Params), BusStudent.fetch(params)])
      commit('changeState', { busStudents, totalItems, busSearchParams: Params, loading: false })
      return busStudents
    },
    setPageText({ state, commit }, { page, itemsPerPage }) {
      const pageStart = (page - 1) * itemsPerPage + 1
      let pageStop = page * itemsPerPage
      pageStop = pageStop > state.totalItems || pageStop === -1 ? state.totalItems : pageStop
      let pageText = `${pageStart}-${pageStop} trên ${state.totalItems}`
      commit('changeState', { pageText })
    },
    async addStudentInBusStops({ dispatch }, params) {
      await BusStop.addStudentInBusStops(params)
      await dispatch('getBusStudentByPagination', {})
    },
    async getBusStudentByPagination({ state, dispatch }, { page, itemsPerPage }) {
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      let params = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        _sort: 'updatedAt:desc',
      }
      await dispatch('getBusStudents', params)
      await dispatch('setPageText', { page, itemsPerPage })
    },
    async filterBusStudents({ dispatch }, params) {
      await dispatch('getBusStudents', params)
    },
    async deleteStudent({ dispatch, state }, id) {
      await BusStudent.remove(id)
      await dispatch('getBusStudents', state.busSearchParams)
    },
  },
  mutations: {},
  getters: {},
}
